module.exports = __webpack_public_path__ + "static/media/edit.37a92523.svg";